import styled from "styled-components";
import { SLTable } from "~/pages/Sistema/componentes/SistemaList";
import { SistemaComponenteInterno } from "~/pages/Sistema/componentes";

export const ThisContainer = styled(SistemaComponenteInterno)`
    margin-top: 1.5em;
`;

export const ThisTable = styled(SLTable)``;

